import gql from 'graphql-tag';

export const SubPortalQuery = gql`
query SubPortal($id:ID!){
    SubPortal(id:$id){
        configObjectId
    name
    configObjectType
    createdBy
    isDeleted
    itemDescription
    insert_ts
    projectId
    updatedBy
    update_ts
    deletionDate
    portalType
    archived
    favorite
    modalRequired
    portalDataSharing
    tabGroup
    order
    layoutType
    accessibilityRegex
       childRelations {
            relationType
            childItemId
            insert_ts
            update_ts
            createdBy
            updatedBy
         }
          parentRelations {
           relationType
           parentItemId
           insert_ts
           update_ts
           createdBy
           updatedBy
         }
          privileges {
           privilegeType
           roleId
           insert_ts
           update_ts
           createdBy
           updatedBy
         }
    }
    
}`;